<template>
  <div class="about">
    <h1 class="about-title">关于</h1>
    <div>
      <p>从明天起，做一个幸福的人<br>
        喂马、劈柴，周游世界<br>
        从明天起，关心粮食和蔬菜<br>
        我有一所房子，面朝大海，春暖花开
      </p>
      <p>
        从明天起，和每一个亲人通信<br>
        告诉他们我的幸福<br>
        那幸福的闪电告诉我的<br>
        我将告诉每一个人
      </p>
      <p>
        给每一条河每一座山取一个温暖的名字<br>
        陌生人，我也为你祝福<br>
        愿你有一个灿烂的前程<br>
        愿你有情人终成眷属<br>
        愿你在尘世获得幸福<br>
        我只愿面朝大海，春暖花开
      </p>
      <p>—— 海子 ——</p>
    </div>
  </div>
</template>
<style lang="scss" scope>
@import '@/scss/public.scss';

.about-title {
  text-align: center;
  font-size: 22px;
  margin-bottom: 40px;
}
p {
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  color: $color-gray;
}
</style>

<script>
export default {
  name: 'Abount',
  components: {
  },
}
</script>